import { render, staticRenderFns } from "./experienceForm - 副本.vue?vue&type=template&id=1c51c745&scoped=true"
import script from "./experienceForm - 副本.vue?vue&type=script&lang=js"
export * from "./experienceForm - 副本.vue?vue&type=script&lang=js"
import style0 from "./experienceForm - 副本.vue?vue&type=style&index=0&id=1c51c745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c51c745",
  null
  
)

export default component.exports